export function deriveYearsOfExperience(
  startYear: number | null | undefined,
  now = new Date()
): number | null {
  const currentYear = now.getFullYear();
  if (
    !Number.isInteger(startYear)
    || startYear === null
    || startYear === undefined
    || startYear < 1950
    || startYear > currentYear
  ) {
    return null;
  }

  return Math.max(0, currentYear - startYear);
}
